export default {
  afterSalesDeduction: {
    title: '售后费用扣款 (Trial)',
    orderStatus: '单据状态',
    all: '所有',
    pendingBusinessReview: '待业务审核',
    pendingSettlement: '待结算',
    completed: '已完成',
    orderNumber: '订单号',
    aftersalesNumber: '售后单号',
    skuNumber: '商城SKU号',
    feeType: '费用类型',
    aftersalesReturnShippingFee: '售后退回运费',
    seriousViolationPenalty: '严重违规',
    aftersalesRepairFee: '售后维修费用',
    customerNumber: 'Customer#',
    productTitle: '商品Title',
    exportExcel: '导出Excel',
    creationTime: '生成时间',
    deductionOrderNo: '扣款单号',
    aftersalesOrderNo: '售后单号',
    currency: '币种',
    amount: '金额',
    aftersalesMethod: '售后方式',
    settlementTransactionNo: '结算流水号',
    createdTime: '生成时间',
    status: '状态',
    settlementCompletedTime: '结算完成时间'
  },
  logisticsDeduction: {
    title: '物流费用和扣款 (Trial)',
    orderStatus: '单据状态',
    all: '所有',
    pendingAudit: '待业务审核',
    pendingSettlement: '待结算',
    settled: '已完成',
    waybillNo: '运单号',
    productTitle: '商品Title',
    marketplaceSku: '商城SKU号',
    exportExcel: '导出Excel',
    creationTime: '扣款单生成时间',
    settlementTime: '结算完成时间',
    deductionOrderNo: '扣款单号',
    businessNo: '业务单据号',
    currency: '币种',
    amount: '金额',
    type: '类型',
    fundAccount: '商家资金账号',
    status: '状态',
    pendingFinanceAudit: '待财务审核',
    pleaseSelectTime: '请选择时间'
  },
  orderCancel: {
    title: '订单取消扣款 (Trial)',
    orderStatus: '单据状态',
    all: '所有',
    toBeEffective: '待生效',
    invalidated: '已失效',
    deducted: '已扣款',
    skuNumber: '商城SKU号',
    listingNumber: 'Listing#',
    orderNumber: 'Order# or SN',
    exportExcel: '导出Excel',
    fineId: 'FineID',
    orderSn: 'OrderSN',
    currency: 'Currency',
    fineAmount: 'FineAmount',
    reasonType: 'ReasonType',
    orderTime: 'OrderTime',
    payTime: 'PayTime',
    cancelTime: 'CancelTime',
    operator: 'Operator#',
    logTime: 'LogTime',
    fineStatus: 'FineStatus'
  },
  productViolation: {
    title: '商品违规下架扣款 (Trial)',
    status: '单据状态',
    all: '所有',
    toBeEffective: '待生效',
    invalidated: '已失效',
    deducted: '已扣款',
    listingNumber: 'Listing#',
    productTitle: '商品名称',
    exportExcel: '导出Excel',
    fineId: '罚款单号',
    currency: '币种',
    fineAmount: '罚款金额',
    catId: '分类 ID',
    submitType: '提交类型',
    credentialNumber: '凭证编号',
    logTime: '日志记录时间',
    deductionTime: '扣款时间',
    fineStatus: '罚款状态'
  },
  settlementArrear: {
    title: '欠费补缴单 (Trial)',
    status: '单据状态',
    all: '所有',
    pendingFinancialAudit: '待财务审核',
    pendingSettlement: '待结算',
    completed: '已完成',
    selectPeriod: '请选择账期',
    arrearsOrderNo: '欠费补缴单号',
    currency: '币种',
    amount: '金额',
    settlementPeriod: '所属帐期',
    creationTime: '生成时间',
    statusLabel: '状态',
    settledTime: '结算完成时间',
    operation: '操作',
    details: '详情',
    detailTitle: '欠费补缴单详情',
    fundAccount: '所属资金户',
    arrearsAmount: '欠费金额',
    generatedDetails: '产生明细',
    marketplaceOrderSettlement: '商城订单结算',
    logisticsWarehouseFee: '物流扣款/仓储费',
    platformMaintenanceFee: '商城扣款/售后退款',
    billingPeriod: '所属账期',
    settlementStatus: '结算状态',
    settlementTime: '结算时间',
    close: '关闭',
    pendingAudit: '待审核',
    pendingPayment: '待缴费',
    paid: '已实缴',
    deferredSettlement: '已顺延结算'
  },
  expressCompensation: {
    title: '丢损件赔付单 (Trial)',
    orderStatus: '单据状态',
    all: '所有',
    waybillNo: '运单号',
    skuNumber: '商城SKU号',
    productTitle: '商品Title',
    exportExcel: '导出Excel',
    creationTime: '赔付单生成时间',
    settlementTime: '结算完成时间',
    pleaseSelectTime: '请选择时间',
    compensationOrderNo: '赔付单号',
    businessReferenceNo: '业务单据号',
    sku: 'SKU',
    compensationQty: '赔付Qty',
    currency: '币种',
    totalAmount: '金额',
    productCompensation: '商品赔付',
    commissionCompensation: '佣金赔付',
    fundAccount: '商家资金账号',
    createdTime: '生成时间',
    status: '状态',
    operations: '操作',
    details: '详情',
    // 状态
    statusCreated: '待生成金额',
    statusAmountGenerated: '待确认金额',
    statusAmountConfirmed: '待财务审核',
    statusApproved: '待结算',
    statusDone: '已完成',
    statusRefused: '已拒绝',
    // 详情弹窗
    detailTitle: '丢损件赔付-详情',
    productAndStoreInfo: '商品和店铺信息：',
    skuInfo: 'SKU信息',
    waybillInfo: '运单信息',
    relatedMarketplaceOrderNo: '关联商城订单号',
    belongingStore: '所属店铺',
    lossConfirmationTime: '丢损确定时间',
    compensationOrderGenerationTime: '赔付单生成时间',
    transactionUnitPrice: '交易单价',
    compensationQtyLabel: '赔付个数',
    compensationOrderStatus: '赔付单状态',
    compensationAmount: '赔付Amount',
    compensationAmountLabel: '赔付金额',
    commissionDeduction: '佣金扣除',
    actualProductCompensation: '实际商品赔付',
    compensationOrderStatusLabel: '赔付单状态：',
    verifiedQty: '核定Qty',
    verifiedAmount: '核定金额',
    verificationTime: '核定金额时间',
    businessAuditTime: '业务审核时间',
    financialAuditTime: '财务审核时间',
    settlementTimeLabel: '结算时间',
    rejectionReason: '驳回说明',
    close: '关闭'
  },
  settlementBillDocuments: {
    title: '帐单列表 (Trial)',
    displayMode: '展示方式',
    viewByBusinessUnit: '按业务分别呈现',
    aggregateView: '聚合展示',
    selectSettlementPeriod: '选择账期',
    selectBillType: '选择帐单类型',
    selectSettlementStatus: '选择结算状态',
    selectStatementDateRange: '选择帐单包含日',
    billingReference: '帐单业务凭据',
    settlementPeriod: '所属帐期',
    currency: '币种',
    billAmount: '帐单金额',
    billType: '帐单类型',
    marketplaceOrderSettlement: '商城订单支付结算',
    marketplaceFeesAftersales: '商城费用和售后',
    logisticsWarehouseFees: '物流和仓库费用',
    settlementAccount: '结算至帐户',
    occurrenceTime: '发生时间',
    status: '状态',
    settlementStatus: '结算状态',
    settled: '已结算',
    billingInProgress: '出账中',
    pendingConfirmation: '待审核确认',
    pendingSettlement: '待结算',
    periodDuration: '帐期时段',
    billingDuration: '帐期时段',
    actions: '操作',
    expand: '展开',
    download: '下载',
    feeDetails: '费用明细'
  },
  repairCost: {
    title: '售后维修费 (Trial)',
    skuNumber: '商城SKU号',
    periodType: '账期类型',
    weekly: '周结',
    monthly: '月结',
    periodCode: '账期',
    importTime: '导入时间',
    startDate: '开始日期',
    endDate: '结束日期',
    search: '查询',
    reset: '重置',
    feeId: '费用ID',
    repairStatus: 'Repair Status',
    productType: 'Product Type',
    brand: 'Brand',
    productModel: 'Product Model',
    shopId: 'Shop ID',
    shopName: 'Shop Name',
    skuNo: 'SKU No.',
    skuPrice: 'SKU Price',
    quantity: 'Quantity',
    priceQuotation: 'Price Quotation',
    remark: 'Remark',
    applyTime: '申请时间',
    periodCodeLabel: '账期',
    operator: '录入/导入人',
    effectiveTime: '导入/生效时间'
  },
  billingBreakdown: {
    title: '计费明细详情',
    selectSettlementPeriod: '选择账期',
    selectBillType: '选择帐单类型',
    startDate: '从某日期',
    endDate: '到某日期',
    referenceId: '凭据ID',
    objectId: 'ObjID',
    export: '导出',
    feeId: '费用id',
    subject: '科目',
    feeItem: '费项',
    postingDate: '发生日(记费日)',
    currency: '币种',
    direction: '方向',
    transactionAmount: '发生金额',
    site: '站点',
    referenceType: '凭据类型',
    objectType: '对象类型',
    unitPrice: '单价',
    qty: 'Qty',
    keyParams: 'KeyParams',
    billingPeriod: '所属帐期',
    pleaseSelectPeriod: '请选择账期',
    exportGenerating: '正在生成导出文件，请稍候…',
    exportTimeout: '导出等待超时，请稍后重试',
    exportMissingParams: '缺少商家账单号或账单类型，无法导出'
  },
  settlementEntity: {
    title: '结算主体和结算信息',
    selectTip: '请选择当前商户下的结算主体（公司）',
    companyName: '企业名称',
    registrationNo: '公司注册编号',
    legalPersonName: '法人名称',
    companyLocation: '公司所在地',
    confirmApply: '确定应用',
    changePendingTip: '该实体有正在进行的结算卡信息变更申请，暂不可选择',
    modificationPending: '有正在进行的结算信息变更申请，为避免操作冲突，暂时不能在此处操作选择结算实体',
    applyConfirm: '选择唯一结算主体公司，只能选择一次，您确定要继续吗？',
    confirmTitle: '提示',
    confirm: '确定',
    cancel: '取消'
  }
}
